import styled, { css } from 'styled-components';
import Button from '../../button';
import Typography from '../../typography';
import { modernViewportUnit, pxToRem } from '../../../design-tokens/style-utilities';
const MODAL_SIZES = {
    s: { width: '100%', maxWidth: pxToRem('364') },
    m: { width: '50vw', maxWidth: pxToRem('562') },
    l: { width: '80vw', maxWidth: pxToRem('752') },
};
const getModalBorder = ({ position }) => ({ theme }) => css `
		&::after {
			content: '';
			position: absolute;
			${position === 'top' &&
    css `
				top: 0;
			`}
			right: -${pxToRem(theme.spacing['200'])};
			${position === 'bottom' &&
    css `
				bottom: 0;
			`}
			left: -${pxToRem(theme.spacing['200'])};
			height: ${pxToRem(theme.borderWidth['2'])};
			background-color: ${theme.colors.light.dividerModal};

			@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
				right: -${pxToRem(theme.spacing['300'])};
				left: -${pxToRem(theme.spacing['300'])};
			}
		}
	`;
/**
 * Modal container
 */
export const modalContainerStyles = ({ theme }) => css `
	z-index: ${Number(theme.zIndex.popUp) + 1};
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: ${modernViewportUnit(100, 'dvh')};
	background-color: ${theme.colors.base.overlay};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		display: flex;
		justify-content: center;
		align-items: center;
	}
`;
export const ModalContainer = styled.div `
	${modalContainerStyles}
`;
export const receiptModalWrapperStyles = ({ theme, $size, $fullSize, $short, $showFade, $fadeOffset, }) => css `
	z-index: ${Number(theme.zIndex.popUp) + 3};
	position: relative;
	display: flex;
	flex-direction: column;
	width: calc(100% - ${pxToRem(theme.spacing['200'])} * 2);
	max-height: calc(
		${modernViewportUnit($short ? 50 : 100, 'dvh')} - ${pxToRem(theme.spacing['200'])} * 2
	);
	margin: ${pxToRem(theme.spacing['200'])};
	padding: ${pxToRem(theme.spacing['200'])};
	border-radius: ${pxToRem(theme.borderRadius.m)};
	background-color: ${theme.colors.blanc.bgModal};

	${$fullSize &&
    css `
		padding: 0;
	`}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		max-height: ${modernViewportUnit($short ? 50 : 90, 'dvh')};
		width: auto;
		margin: 0;
		padding: ${pxToRem(theme.spacing['300'])};

		${$fullSize &&
    css `
			padding: 0;
		`}

		${$size &&
    css `
			width: ${$size && MODAL_SIZES[$size].width};
			max-width: ${$size && MODAL_SIZES[$size].maxWidth};
		`}
	}

	${$showFade &&
    css `
		&::after {
			content: '';
			position: absolute;
			right: 0;
			bottom: ${pxToRem(Number(theme.spacing['200']) + $fadeOffset)};
			left: 0;
			height: ${pxToRem(theme.spacing['700'])};
			border-bottom-left-radius: ${pxToRem(theme.borderRadius.m)};
			border-bottom-right-radius: ${pxToRem(theme.borderRadius.m)};
			background: ${theme.colors.gradients.overlayReadMore};
			pointer-events: none;

			@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
				bottom: ${pxToRem(Number(theme.spacing['300']) + $fadeOffset)};
			}
		}
	`}
`;
export const ModalWrapper = styled.div `
	${receiptModalWrapperStyles}
`;
export const receiptModalHeaderStyles = ({ theme, $fullSize, $isScrollable, $isScrolled, }) => css `
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding-bottom: ${pxToRem(theme.spacing['200'])};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		padding-bottom: ${pxToRem(theme.spacing['300'])};
	}

	${$isScrollable && $isScrolled && getModalBorder({ position: 'bottom' })}

	${$fullSize &&
    css `
		position: absolute;
		top: ${pxToRem(theme.spacing['200'])};
		right: ${pxToRem(theme.spacing['200'])};
		left: ${pxToRem(theme.spacing['200'])};
	`}
`;
export const ModalHeader = styled.div `
	${receiptModalHeaderStyles}
`;
/**
 * Modal title
 */
export const receiptModalTitleStyles = () => css `
	margin-bottom: 0;
`;
export const ModalTitle = styled(Typography) `
	${receiptModalTitleStyles}
`;
/**
 * Modal close
 */
export const modalCloseStyles = ({ theme }) => css `
	z-index: ${Number(theme.zIndex.popUp) + 5};
	position: relative;
	padding: 0;
	margin-left: auto;
	background-color: transparent;
	cursor: pointer;
	color: ${theme.colors.highlight.iconInteractive};
	width: auto;
	height: auto;
	border: none;

	&:focus,
	&:hover {
		color: ${theme.colors.highlight.iconInteractive};
	}

	/* Increase hitbox */
	&::after {
		content: '';
		position: absolute;
		inset: -${pxToRem(theme.spacing['200'])} -${pxToRem(theme.spacing['200'])} -${pxToRem(theme.spacing['200'])} -${pxToRem(theme.spacing['200'])};
		padding: 0;

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
			inset: -${pxToRem(theme.spacing['300'])} -${pxToRem(theme.spacing['300'])} -${pxToRem(theme.spacing['300'])} -${pxToRem(theme.spacing['300'])};
		}
	}
`;
export const ModalClose = styled.button `
	${modalCloseStyles}
`;
export const receiptModalContentStyles = ({ theme, $fullSize, $isScrollable, }) => css `
	overflow: hidden auto;
	-webkit-overflow-scrolling: touch;

	${$fullSize &&
    css `
		border-radius: ${pxToRem(theme.borderRadius.m)};
	`}

	${$isScrollable &&
    css `
		margin-right: -${pxToRem(theme.spacing['200'])};
		padding-right: ${pxToRem(theme.spacing['200'])};

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
			margin-right: -${pxToRem(theme.spacing['300'])};
			padding-right: ${pxToRem(theme.spacing['300'])};
		}
	`}

	& > *:first-child {
		margin-top: 0;
	}

	a {
		word-break: break-all;
	}
`;
export const ModalContent = styled.div `
	${receiptModalContentStyles}
`;
export const receiptModalFooterStyles = ({ theme, $isScrollable, $isScrolled, }) => css `
	position: relative;
	display: flex;
	gap: ${pxToRem(theme.spacing['200'])};
	justify-content: flex-end;
	flex-direction: column;
	width: 100%;

	${$isScrollable &&
    css `
		padding-top: ${pxToRem(theme.spacing['200'])};

		${$isScrolled && getModalBorder({ position: 'top' })}

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
			padding-top: ${pxToRem(theme.spacing['300'])};
		}
	`}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		flex-direction: row;
		gap: ${pxToRem(theme.spacing['300'])};
	}
`;
export const ModalFooter = styled.div `
	${receiptModalFooterStyles}
`;
/**
 * Modal footer button
 */
export const receiptModalFooterButtonStyles = ({ theme }) => css `
	& + & {
		margin-top: ${pxToRem(theme.spacing['200'])};

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			margin-top: 0;
		}
	}
`;
export const ModalFooterButton = styled(Button) `
	${receiptModalFooterButtonStyles}
`;
